import { EnrolmentsListView } from '../Components/EnrolmentsListView';

export default function CancelledEnrolmentsPage() {
  return (
    <EnrolmentsListView
      fixedStatusID={-1}
      title="Cancelled Enrolments"
      subtitle="Enrolments that were cancelled"
    />
  );
}
